import React from "react";
import Image from "../components/elements/Image";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const FrontFooter = () => {
  const { t } = useTranslation();

  const footerLinks = [
    {
      id: 1,
      title: t("Use Dancebrite"),
      links: [
        t("Create Events"),
        t("Pricing"),
        t("Event Marketing Platform"),
        t("Event Registration Software"),
        t("Community Guidelines"),
        t("FAQs"),
        t("Sitemap"),
      ],
    },
    {
      id: 2,
      title: t("Plan Events"),
      links: [
        t("Sell Tickets Online"),
        t("Event Payment System"),
        t("Event Management"),
        t("QR Codes For Event Check-In"),
        t("Post Your Event Online"),
      ],
    },
    {
      id: 3,
      title: t("Find Events"),
      links: [
        t("London"),
        t("Birmingham"),
        t("Manchester"),
        t("Liverpool"),
        t("Newcastle"),
        t("International"),
      ],
    },
    {
      id: 4,
      title: t("Connect With Us"),
      links: [t("Instagram"), t("TikTok"), t("Twitter"), t("Facebook")],
    },
  ];

  return (
    <footer className="py-16 w-full bg-gradient-to-r from-[#41068D] via-[#7C26FA] to-[#5311B4] mt-auto">
      <div className="w-full max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 px-6 lg:px-0">
          <div className=" md:col-span-7 lg:col-span-3 space-y-10 lg:space-y-20">
            <Link to={"/"} className="w-40 aspect-square overflow-hidden block">
              <Image
                src={require("../assets/images/Footer logo.png")}
                classes={"object-contain"}
              />
            </Link>
            <div className="text-white text-sm font-medium">
              {t(`© 2025 dancebrite - All rights reserved`)}
            </div>
          </div>
          <div className=" md:col-span-12 lg:col-span-9">
            <div className="grid grid-cols-12 gap-6 lg:gap-10">
              {footerLinks.map((section, index) => (
                <div key={index} className="col-span-12 md:col-span-3">
                  <div className="text-xl capitalize font-bold text-magnolia mb-5">
                    {section.title}
                  </div>
                  <ul className="flex flex-col gap-1">
                    {section.links.map((linkText, idx) => (
                      <li key={idx} className="relative">
                        <Link
                          to="#"
                          className="inline-block text-base text-magnolia capitalize transition-all duration-300 hover:translate-x-4"
                        >
                          {linkText}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FrontFooter;
